import React, { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import NotFound from '../../Body/NotFound';

// Define the type for props
interface ErrorBoundaryProps {
  fallback: ReactNode;
  children: ReactNode;
}

// Define the logErrorToMyService function (you can replace it with your actual implementation)
const logErrorToMyService = (error: Error) => {
  // Log the error to your service
  console.error(error);
};

// Define the ErrorFallback component
const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  return <NotFound />;
};

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  fallback,
  children,
}) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => logErrorToMyService(error)}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
